import React, { useEffect, useMemo } from 'react';
import SignupContentWrapper from '../../components/SignupContentWrapper';
import OrganizationAutoCompleteV1 from './v1';
import OrganizationAutoCompleteV2 from './v2';
import { useTranslation } from 'react-i18next';
import { useRouteConfig } from '../../utils/useRouteConfig';
import { PATH } from '../../../../routes';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { AppState } from 'store';
import { Features } from 'store/featureFlags/types';
import { useV2Translation } from './v2/translation';
import { signSetAction } from 'store/signup/actions';
import { SignupState } from 'store/signup/types';
import { useFullStoryIdentity } from 'pages/signup/utils/useFullStoryIdentity';

const STEP_INFO = 1;

const OrganizationName: React.FC = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { previous } = useRouteConfig(PATH.SIGNUP.STEPS.ONE);
    const headingV1 = useMemo(() => t('signup.organizationName.heading'), [t]);
    const { heading: headingV2 } = useV2Translation();

    const { fingerprint, fullStoryEnabled, newSearchUIEnabled, enabledFeaturesLoading } = useSelector(
        (state: AppState) => ({
            fingerprint: state.Signup.fingerprint,
            fullStoryEnabled: 
                state.FeatureFlagging.features[Features.FULLSTORY],
            newSearchUIEnabled:
                state.FeatureFlagging.features[Features.SEARCH_UI_V2],
            enabledFeaturesLoading: state.FeatureFlagging.isLoading,
        }),
    );

    useEffect(() => {
        const data = sessionStorage.getItem('organizationSearch');
        if (data) {
            const result = JSON.parse(data) as Partial<SignupState>;
            dispatch(
                signSetAction({
                    organizationName: result.organizationName,
                    organizationLocation: result.organizationLocation,
                    organizationCountry: result.organizationCountry,
                }),
            );
        }
    }, [dispatch, newSearchUIEnabled]);

    useFullStoryIdentity({
        enabled: fullStoryEnabled && newSearchUIEnabled,
        fingerprint,
    });

    if (enabledFeaturesLoading) {
        return null;
    }

    return (
        <SignupContentWrapper
            showCloseButton={true}
            heading={newSearchUIEnabled ? headingV2 : headingV1}
            stepInfo={STEP_INFO}
            backUrl={previous}
        >
            {newSearchUIEnabled ? (
                <OrganizationAutoCompleteV2 />
            ) : (
                <OrganizationAutoCompleteV1 />
            )}
        </SignupContentWrapper>
    );
};

export default OrganizationName;
